import { ROLES } from './strings';

export const allowToViewCSMCaseload = (role, additionalRoles = []) => {
    return [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.CSM, ...additionalRoles].includes(role);
};

export const showAddClientButton = (role, additionalRoles = []) => {
    return [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.CONTENT_MANAGER, ...additionalRoles].includes(
        role,
    );
};

export const isAdminRole = (role) => {
    return [ROLES.SUPER_ADMIN, ROLES.ADMIN].includes(role);
};
export const isCSMRole = (role) => {
    return [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.CSM].includes(role);
};
export const isContentManagerRole = (role) => {
    return [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.CONTENT_MANAGER].includes(role);
};

export const uptoContentManagerRole = (role) => {
    return [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.CSM, ROLES.CONTENT_MANAGER].includes(role);
};

export const allManagementRole = (role) => {
    return [
        ROLES.SUPER_ADMIN,
        ROLES.ADMIN,
        ROLES.CSM,
        ROLES.CONTENT_MANAGER,
        ROLES.SALES_AGENT,
    ].includes(role);
};
